import React from 'react';
import {
  MyAuditViewCommentsWrapper,
  TaggedUsersContainer,
} from './styled.MyAuditView';
import { SearchBoxTaggedUsers } from '../../../myAudit/components/SearchBoxTaggedUsers';
import { TextArea } from '../../../common/sharedComponents/TextArea';
import { MealPeriodDropdown } from '../../../myAudit/components/MealPeriodDropdown';
import { ISelectedOption } from '../../../@types/searchBox';
import { convertName } from '../../../../helpers/convertName';
import { useTranslation } from 'react-i18next';
import { Nullable } from '../../../@types/genericTypes';
import { MealPeriodTypes } from '../../../@types/myAudit';

export interface IMyAuditViewComments {
  tagged?: (Nullable<number> | ISelectedOption)[];
  comments?: Nullable<string>;
  roomNumber?: Nullable<string>;
  outletName?: string;
  mealPeriod?: MealPeriodTypes;
}

export function MyAuditViewComments ({
  tagged,
  comments,
  roomNumber,
  outletName,
  mealPeriod,
}: IMyAuditViewComments) {
  const { t } = useTranslation();

  return (
    <MyAuditViewCommentsWrapper>
      {tagged && (
        <TaggedUsersContainer>
          <SearchBoxTaggedUsers
            disabled={true}
            initialState={tagged as ISelectedOption[]}
          />
        </TaggedUsersContainer>
      )}
      <TextArea
        title={t('COMMON.MY_AUDIT.CONDUCT.COMMENTS.MY_AUDIT_COMMENTS.TITLE')}
        textValue={comments}
        placeholder={t(
          'COMMON.MY_AUDIT.CONDUCT.COMMENTS.MY_AUDIT_COMMENTS.PLACEHOLDER'
        )}
        disabled={true}
      />
      {roomNumber && (
        <TextArea
          title={t('COMMON.MY_AUDIT.CONDUCT.COMMENTS.ROOM_NUMBER.TITLE')}
          textValue={roomNumber}
          placeholder={t(
            'COMMON.MY_AUDIT.CONDUCT.COMMENTS.ROOM_NUMBER.PLACEHOLDER'
          )}
          disabled={true}
        />
      )}
      {outletName && (
        <TextArea
          title={t('COMMON.MY_AUDIT.CONDUCT.COMMENTS.OUTLET.TITLE')}
          textValue={outletName}
          placeholder={t('COMMON.MY_AUDIT.CONDUCT.COMMENTS.OUTLET.PLACEHOLDER')}
          disabled={true}
        />
      )}
      {mealPeriod && (
        <MealPeriodDropdown
          defaultOption={{
            value: mealPeriod,
            label: convertName(mealPeriod),
          }}
          disabled={true}
        />
      )}
    </MyAuditViewCommentsWrapper>
  );
}
